import initialState from './initial.state';
import * as types from '../actions/types.action';

export default function errorsReducer(state = initialState.errors, action) {
  switch (action.type) {
    case types.SET_SERVER_ERROR:
      return Object.assign({}, state, {
        server: action.error
      });
    case types.SET_FULFILLMENT_ERROR:
      return Object.assign({}, state, {
        fulfillment: action.error
      });
    case types.SET_ITEM_ERROR:
      return Object.assign({}, state, {
        item: action.error
      });
    case types.SET_PAYMENT_ERROR:
      return Object.assign({}, state, {
        payment: action.error
      });
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./reducers/error.reducer.js